import { useEffect, useState } from "react"

/**
 * Keeps a leaving element mounted for `delayMs` after `visible` flips false
 * so its opacity transition can play before unmount. `leaving` is true during
 * that grace window — the component applies its fade-out class while leaving.
 */
export function useDelayedUnmount(
  visible: boolean,
  delayMs: number,
): { mounted: boolean; leaving: boolean } {
  const [delayedVisible, setDelayedVisible] = useState(visible)
  useEffect(() => {
    if (visible) {
      setDelayedVisible(true)
      return
    }
    const timer = window.setTimeout(() => setDelayedVisible(false), delayMs)
    return () => window.clearTimeout(timer)
  }, [visible, delayMs])
  return {
    mounted: visible || delayedVisible,
    leaving: !visible && delayedVisible,
  }
}
